import Vue from 'vue';
import VueI18n from 'vue-i18n';
import fr from './locales/fr.json';
import it from './locales/it.json';
import { detectCountry } from './services/countries';

Vue.use(VueI18n);

const country = detectCountry();
const locale = country === 'IT' ? 'it' : 'fr';

const i18n = new VueI18n({
  locale,
  fallbackLocale: 'fr',
  messages: { fr, it },
  silentFallbackWarn: true,
  silentTranslationWarn: process.env.NODE_ENV === 'production',
});

export const BCP47 = { fr: 'fr-FR', it: 'it-IT' };

Vue.prototype.$localeDate = function (date, opts) {
  const tag = BCP47[this.$i18n.locale] || 'fr-FR';
  const d = date instanceof Date ? date : new Date(date);
  return d.toLocaleDateString(tag, opts);
};

Vue.prototype.$localeDateTime = function (date, opts) {
  const tag = BCP47[this.$i18n.locale] || 'fr-FR';
  const d = date instanceof Date ? date : new Date(date);
  return d.toLocaleString(tag, opts);
};

export default i18n;
